export const policies = `# **Política de Privacidad y Condiciones de Uso**

En **Llanticentro Ceibeño S. de R.L.**, con nombre comercial **ALLAS Repuestos**, nos preocupamos por tu información personal, por lo que hemos preparado esta Política de Privacidad para explicar cómo la recopilamos, usamos y compartimos.

Esta Política de Privacidad aplica a los sitios web de ALLAS Repuestos, sus aplicaciones móviles y servicios relacionados (“Servicio”).

Al usar el Servicio, aceptas la recopilación, uso y compartición de tu información personal por parte de ALLAS Repuestos de acuerdo con los términos de esta Política.

En ALLAS Repuestos nos tomamos en serio tu privacidad. Esta política explica qué datos recopilamos y cómo los usamos.  
 Nunca vendemos tu información a terceros. Puedes seguir usando la app, aunque rechaces cookies o anuncios personalizados.

Ten en cuenta que ALLAS Repuestos está constantemente probando y mejorando funciones de sus productos. Algunas características descritas en esta Política de Privacidad pueden no estar disponibles para todos los usuarios o en todas las jurisdicciones.

# **Información que Recopilamos**

Cuando utilizas el Servicio, ALLAS Repuestos puede recopilar la siguiente información personal:

## **a) Registro de Cuenta**

Para registrarte, puedes proporcionarnos tu número de teléfono y correo electrónico. También puedes registrarte usando inicios de sesión sociales como Google, Facebook, Apple y Microsoft.  
En ese caso, ALLAS Repuestos puede recibir información de tu proveedor de inicio de sesión, como tu correo electrónico y datos de contacto.  
Puedes administrar tu cuenta e inicios de sesión sociales en **Configuración**.

## **b) Perfil y Contenido Generado por el Usuario**

Al registrarte, se crea una página de perfil (“Perfil”) con información que envíes: nombre, usuario, biografía y foto de perfil (“Contenido Generado por el Usuario”).

Tu edad, número telefónico y correo no se incluyen en tu perfil público. Otros usuarios no podrán buscarte por nombre, correo o teléfono.  
Tu perfil también incluye información sobre tu garaje y garantías.

ALLAS Repuestos puede escanear, revisar o compartir tu contenido con proveedores externos de moderación para asegurar el cumplimiento de las Normas de la Comunidad.  
Podremos restringir o eliminar contenido que las viole.

## **c) Funciones de IA**

El servicio puede ofrecer funciones con inteligencia artificial que permiten enviar mensajes de texto, imágenes o voz a compañeros virtuales.

El texto, imágenes y audio enviados pueden compartirse con proveedores de IA como OpenAI. Podemos grabar, almacenar y usar estas interacciones para mejorar productos, servicios y personalizar tu experiencia.

La Función de IA solo se activa si el usuario lo permite en el proceso de autorización explícito al inicio de la utilización de la app.

Los datos enviados a funciones de IA (texto, imágenes o voz) pueden ser procesados fuera de Honduras.  
No uses esta función para compartir contraseñas, información financiera o datos sensibles.

Puedes desactivar estas funciones en cualquier momento en: **Perfil → Configuración → Privacidad.**

## **d) Datos de Actividad, GPS e IP**

Recopilamos datos de uso: navegador, dispositivo, registros e IP.  
La app también usa tu GPS para ubicar la tienda más cercana o guiarte a ella.

La geolocalización solo se activa si el usuario lo permite en el proceso de autorización explícito al inicio de la utilización de la app, y siempre puede desactivarlo en: **Perfil → Configuración → Privacidad.**

## **e) Cookies/Rastreo**

Usamos cookies en el sitio web y app para confirmar accesos y personalizar tu experiencia.  
 Puedes aceptar o rechazar cookies desde tu navegador y en la app, aunque algunas son necesarias.

Incluyen cookies de segmentación de Google, Facebook, Amazon y otros, que podrían usarse para publicidad personalizada.

Las Cookies/Rastreo se pueden desactivar en: **Perfil → Configuración → Privacidad.**

## **f) Google Analytics**

Utilizamos Google Analytics para comprender cómo interactúan los usuarios con el sitio.  
Esta herramienta usa cookies propias para recopilar información anónima y generar reportes.  
Puedes inhabilitar con el complemento de navegador de Google.

## **g) Política de Niños/Menores**

Nuestros servicios están dirigidos para mayores de 13 años.  
No recopilamos a sabiendas información de menores. Si se detecta, será eliminada inmediatamente.

# **Cómo Procesamos tu Información**

ALLAS Repuestos puede procesar tu información personal con base en: prestación de servicios solicitados, intereses legítimos, cumplimiento de obligaciones legales y tu consentimiento.

## **a) Provisión y Mejora del Servicio**

Usamos tus datos para mantener tu perfil, personalizar contenido, detectar errores, hacer investigación y brindarte soporte.  
 Compartimos información con proveedores de hosting (AWS), buscadores (Google), analítica (Google), y funciones de IA (OpenAI).

## **b) Comunicación**

Enviamos mensajes esenciales para operar el servicio, notificaciones de garantías, cambios en productos y nuevas ofertas.

## **c) Cumplimiento Legal y Prevención de Daños**

Compartimos datos si es necesario por ley, para proteger intereses, prevenir fraudes o asistir a la autoridad.

## **d) Publicidad Personalizada**

Colaboramos con Google, Facebook, entre otros, para mostrar anuncios personalizados basados en tu actividad.  
Puedes seguir usando la aplicación aunque rechaces la publicidad personalizada.

Para desactivarla, escribe a privacidad@allasrepuestos.com.  
La solicitud se procesa en un máximo de **7 días hábiles.**

## **e) Información Anónima**

Podemos procesar datos anonimizados con cualquier propósito. No se consideran información personal.

# **Derechos de los Titulares de Datos**

Tienes derecho a:

* Saber qué datos personales hemos recopilado.  
* Acceder a copias de tus datos.  
* Conocer con qué terceros los hemos compartido.  
* Oponerte a su procesamiento.  
* Limitar el uso de datos sensibles.  
* Solicitar corrección o eliminación.  
* Exportar tus datos en formato electrónico.  
* Retirar tu consentimiento.  
* Eliminar tu cuenta desde la app o la web.

Puedes ejercerlos escribiendo a privacidad@allasrepuestos.com.

**Nota:** no todos los derechos son absolutos; podemos rechazar solicitudes que afecten la ley, derechos de terceros o servicios contratados.

# **Retención de Datos**

Conservamos tu información hasta que elimines tu cuenta, salvo casos legales, disputas o protección de intereses.  
Los datos anónimos se retienen indefinidamente.

# **Señales “Do Not Track”**

El servicio no responde a señales “No rastrear” de navegadores.

# **Enlaces a Terceros**

Podemos enlazar a sitios externos. ALLAS Repuestos no se responsabiliza por sus políticas o prácticas.  
Esta Política aplica únicamente a datos recopilados por nosotros.

# **Actualizaciones**

Podemos actualizar esta Política.  
Si los cambios son significativos, publicaremos un aviso en el sitio por **7 días** antes de que entren en vigor.  
Los cambios relevantes serán notificados en la aplicación y/o por correo electrónico.

# **Transferencia Internacional de Datos**

Procesamos datos en **Honduras** y **Estados Unidos**, donde las protecciones pueden diferir de tu país.

**Llanticentro Ceibeño S. de R.L.** es responsable del procesamiento de datos bajo los **Principios DPF**, incluso si los transfiere a terceros.

Cumplimos con marcos internacionales como el **Data Privacy Framework (DPF)** y principios del **GDPR/CCPA**.  
Esto garantiza que tus datos reciban un nivel de protección adecuado, independientemente de tu ubicación.

# **Contacto**

**Responsable de los datos (GDPR y legislación local):**  
Llanticentro Ceibeño S. de R.L.  
ALLAS Repuestos  
Avenida Junior, 2 Calle N.E.  
San Pedro Sula, Honduras 21101  
**Tel:** \+504 2509-7350  
**Correo:** privacidad@allasrepuestos.com

**Soporte: En App → Perfil → Configuración → Privacidad → Soporte de Privacidad**

# **Preguntas Frecuentes (FAQ)**

* **¿Cómo accedo a mis datos personales?**  
   Solicítalos escribiendo a privacidad@allasrepuestos.com.

* **¿Cómo elimino mi cuenta y datos?**  
   Al eliminar tu cuenta perderás tu garaje, garantías, puntos y beneficios.  
   La eliminación es irreversible y puede tardar hasta **30 días.**

   **Métodos:**

  * En iOS/Android: **Perfil → Configuración → “Eliminar cuenta”**  
  * Escribe a soporte@allasrepuestos.com con tu número de identidad o correo registrado.  
* **¿Eliminar mi cuenta cancela el programa de recompensas?**  
  Sí. Se suspenden todos los créditos y beneficios.  
* **¿Cuál es la Política de Privacidad de ALLAS Repuestos?**  
  Revisa este documento completo o accede en [https://www.allasrepuestos.com/privacidad](https://www.allasrepuestos.com/privacidad.html)

# **Política de Manejo de Datos Personales**

En ALLAS Repuestos nos comprometemos al manejo responsable de los datos conforme a la legislación vigente.

## **a) Principios de Manejo**

Tratamos los datos únicamente para la creación de cuentas digitales y la validación de identidad.  
No usamos la información para fines comerciales ni publicitarios.

Los datos se almacenan en servidores seguros en **Estados Unidos** y solo accede personal autorizado bajo acuerdos de confidencialidad.

## **b) Conservación**

Los datos se conservarán mientras el usuario mantenga una cuenta activa.  
Una vez eliminada la cuenta, se depurará definitivamente en un máximo de **30 días.**

## **c) Seguridad y Cifrado**

Los datos sensibles se cifran y almacenan en servidores que cumplen con normativas internacionales de protección de datos.

## 

# **Política de Eliminación de Datos**

Los usuarios tienen derecho a solicitar la eliminación total de su información y cuenta.

## **a) Procedimiento**

Puedes eliminar tu cuenta directamente desde la app (**Perfil → Configuración → Privacidad → “Eliminar cuenta”**) o enviando una solicitud a privacidad@allasrepuestos.com.

La eliminación se realiza en un plazo máximo de **30 días hábiles.**

## **b) Alcance de la Eliminación**

La eliminación incluye credenciales, datos de verificación (identificación, selfie, OTP) y el historial de uso.

## **c) Confirmación**

Recibirás un correo electrónico confirmando la eliminación total de tus datos y el cierre definitivo de tu cuenta.

## 

# **Términos y Condiciones de Uso**

## **a) Objeto**

La aplicación de ALLAS Repuestos permite a los usuarios crear un perfil digital, verificar su identidad y acceder a beneficios exclusivos.

## **b) Registro de Usuarios**

El usuario debe proporcionar datos verídicos y actualizados.  
ALLAS Repuestos se reserva el derecho de rechazar registros que no cumplan con los criterios.

El usuario es responsable de mantener la confidencialidad de sus credenciales.

## **c) Uso de la Aplicación**

El usuario se compromete a usar la aplicación únicamente para fines legítimos.  
Está prohibido:

* Usar la app con fines ilícitos o fraudulentos.  
* Alterar o modificar el software.  
* Usar datos de terceros sin consentimiento.

## **d) Propiedad Intelectual**

Todo el contenido, logotipos, marcas, diseño y código fuente son propiedad de ALLAS Repuestos.  
El uso de la aplicación no otorga ningún derecho de propiedad intelectual.

## **e) Responsabilidad**

ALLAS Repuestos no garantiza la disponibilidad continua del servicio.  
No se responsabiliza por fallas técnicas o conexión del usuario.  
El uso indebido es responsabilidad exclusiva del usuario.

## **f) Modificaciones**

ALLAS Repuestos puede modificar en cualquier momento estos Términos y Condiciones.  
Las modificaciones entran en vigor una vez publicadas o notificada.

## **g) Legislación Aplicable**

Estos Términos se rigen por las leyes vigentes en la **República de Honduras**, sin perjuicio de normas internacionales aplicables.`;
